export const coreMobileEs = {
    TOAST: {
        DISPENSAR: "Dispensar",
        AGUARDE: "Aguarde"
    },
    COMMON: {
        CLOSE: "Fechar",
        INPUTIMAGE: {
            GALLERY: "Gallery",
            CAMERA: "Camera"
          },
          OPTIONAL: "Optional",
          CANCEL: "Cancelar",
          CONFIRM: "Confirmar"
    }
}